export default "__VITE_ASSET__BAqRkl_d__"